'use strict';

exports.__esModule = true;

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

var _response = require('./response');

var _response2 = _interopRequireDefault(_response);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Created by @玩家 on 2017/2/6.
                                                                                                                                                           */

var Context = function () {
    function Context(puck) {
        _classCallCheck(this, Context);

        this.req = {};
        this.res = new _response2['default']({
            ok: false,
            status: 404,
            statusText: 'Not Found',
            headers: new Headers(),
            body: 'Not Found'
        });

        this.request = puck.request.bind(puck);
    }

    Context.prototype.generateRequest = function generateRequest(url, options) {
        this.req = new _request2['default'](url, options);
        return this;
    };

    Context.prototype.generateResponse = function generateResponse(options) {
        this.res = new _response2['default'](options);
        return this;
    };

    return Context;
}();

exports['default'] = Context;
module.exports = exports['default'];